import PropTypes from 'prop-types';
import { css, etiColors } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { SwitchButton } from '@eti/form';
import { TRACKING_VALUES, useProductSnowplowTracking } from '../../../custom-hooks/useProductSnowplowTracking';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = css`
  align-items: center;
  color: ${etiColors.grayScale[9]};
  display: flex;
  justify-content: flex-end;
`;
const textStyles = css`
  font-size: 0.75rem;
  margin: 0 12px;
`;
const buttonWrapperStyles = css`
  flex-shrink: 0;
`;
const ManulifeSwitchButton = _ref => {
  let {
    isDisabled,
    id,
    productName,
    isSelected
  } = _ref;
  const {
    sendAddToCartEvent
  } = useProductSnowplowTracking(productName);
  const {
    t
  } = useTranslation();
  const handleAddToCartEvent = event => {
    if (event.target.checked) {
      sendAddToCartEvent({
        value: TRACKING_VALUES.SWITCH_BUTTON
      });
    } else {
      sendAddToCartEvent({
        addToCart: false,
        value: TRACKING_VALUES.SWITCH_BUTTON
      });
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperStyles,
    children: [/*#__PURE__*/_jsx("span", {
      className: textStyles,
      children: t('Manulife.AddTraveler.Text')
    }), /*#__PURE__*/_jsx("div", {
      className: buttonWrapperStyles,
      children: /*#__PURE__*/_jsx(SwitchButton, {
        id: `${productName}-traveler-${id}.selected`,
        isChecked: isSelected,
        isDisabled: isDisabled,
        name: `traveler-${id}.selected`,
        onChange: handleAddToCartEvent
      })
    })]
  });
};
ManulifeSwitchButton.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  productName: PropTypes.string
};
export default ManulifeSwitchButton;
//# sourceMappingURL=ManulifeSwitchButton.js.map